import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';

import * as types from './actionTypes';

export const setAdditionalUserInfo = createAction(types.SET_ADDITIONAL_USER_INFO, (response) => response.body);
export const setRole = createAction(types.SET_ROLE, (role) => ({ role }));

export const fetchAdditionalUserInfo = () => (dispatch) =>
	dispatch(
		fetch.actions.get(fetch.constants.urls.user, {
			onSuccess: [setAdditionalUserInfo],
		}),
	);

export const fetchAdditionalUserInfoWithPlaceholder = () => (dispatch) =>
	dispatch(
		fetch.actions.get(fetch.constants.urls.user, {
			uniqueReqID: 'placeholder',
			onSuccess: [setAdditionalUserInfo],
		}),
	);
